'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = require('redux-saga/effects');

var _action_type = require('../constants/action_type');

var _util_file = require('../utils/util_file');

var _fetcher_mol = require('../fetchers/fetcher_mol');

var _fetcher_mol2 = _interopRequireDefault(_fetcher_mol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(analysisMol),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(convertMol);

function analysisMol(action) {
  var payload, mol, isValidMolExt, isValidSize;
  return regeneratorRuntime.wrap(function analysisMol$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = action.payload;
          mol = payload.mol;
          isValidMolExt = (0, _util_file.VerifyMolExt)(mol);
          isValidSize = (0, _util_file.VerifySize)(mol);

          if (!(isValidMolExt && isValidSize)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({
            type: _action_type.MOL.ADD_DONE,
            payload: payload
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({
            type: _action_type.MOL.ADD_FAIL,
            payload: payload
          });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked);
}

var getMolSrc = function getMolSrc(state) {
  return state.mol.src;
};

function convertMol(action) {
  var payload, mol, rsp, smi, mass, svg;
  return regeneratorRuntime.wrap(function convertMol$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = action.payload;
          _context2.t0 = payload.mol;

          if (_context2.t0) {
            _context2.next = 6;
            break;
          }

          _context2.next = 5;
          return (0, _effects.select)(getMolSrc);

        case 5:
          _context2.t0 = _context2.sent;

        case 6:
          mol = _context2.t0;
          _context2.next = 9;
          return (0, _effects.call)(_fetcher_mol2.default.convertMol, { mol: mol });

        case 9:
          rsp = _context2.sent;

          if (!(rsp && rsp.status)) {
            _context2.next = 16;
            break;
          }

          smi = rsp.smi, mass = rsp.mass, svg = rsp.svg;
          _context2.next = 14;
          return (0, _effects.put)({
            type: _action_type.MOL.CONVERT_DONE,
            payload: Object.assign({}, {
              mol: mol, smi: smi, mass: mass, svg: svg
            })
          });

        case 14:
          _context2.next = 18;
          break;

        case 16:
          _context2.next = 18;
          return (0, _effects.put)({
            type: _action_type.MOL.CONVERT_FAIL,
            payload: payload
          });

        case 18:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2);
}

var molSagas = [(0, _effects.takeEvery)(_action_type.MOL.ADD_INIT, analysisMol), (0, _effects.takeEvery)(_action_type.MOL.ADD_DONE, convertMol)];

exports.default = molSagas;